"use client";
import { anatomy } from "@zag-js/carousel";
//#region src/components/carousel/carousel.anatomy.ts
var carouselAnatomy = anatomy.extendWith("progressText", "autoplayIndicator");
//#endregion
export { carouselAnatomy };
